module.exports = __webpack_public_path__ + "img/img.5826730e.png";